import React, { useContext } from "react";

// Context imports
import { TimekeepingContext } from "../../../context/domain/timekeeping/TimekeepingContext";

import { UI_COPY } from "../../../config";
import { useUiText } from "../../../hooks/useUiText";

/**
 * Displays the users name and the week ending date for their timesheet.
 *
 * @param {Object} props Component props.
 * @param {Object} props.user Current user (`first_name`, `last_name`).
 * @param {string} [props.className] Extra wrapper classes.
 * @returns {JSX.Element}
 */
const Title = ({ user, className }) => {
  const { weekEnd } = useContext(TimekeepingContext);
  const { t, formatUiDate } = useUiText();

  return (
    <div
      className={`grid grid-cols-2 grid-rows-2 gap-0 w-full rounded ${className}`}
    >
      <div className="bg-gray-300 p-2 font-bold rounded-tl flex items-center justify-center">
        {t(UI_COPY.timesheet.name)}
      </div>
      <div className="bg-gray-300 p-2 font-bold rounded-tr flex items-center justify-center">
        {t(UI_COPY.timesheet.weekEnding)}
      </div>
      <div className="bg-gray-100 p-2 rounded-bl flex items-center justify-center">
        {user.first} {user.last}
      </div>
      <div className="bg-gray-100 p-2 rounded-br flex items-center justify-center">
        {weekEnd
          ? formatUiDate(weekEnd, "d month DD, YYYY")
          : t(UI_COPY.timesheet.notAvailable)}
      </div>
    </div>
  );
};

export default Title;
